import {
    HomeIcon,
    UpdateIcon,
} from '@radix-ui/react-icons';
import { useState } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from '../ui/dropdown-menu';
import { toast } from '../ui/use-toast';

function ReturnLoanedBunnyDialog({ bunny, driver, fetchDrivers }) {

    const [isLoading, setIsLoading] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false); // Manage dialog open state

    const handleChange = async (e) => {
        e.preventDefault();
        if (isLoading) return;

        setIsLoading(true);
        try {
            await api.post(`https://skhrf-api.cmdigital.se/v1/bunnies/return`, {
                returnFromId: driver.driver_id,
                bunnyId: bunny.id,
            });
            fetchDrivers();
            toast({
                title: 'Kanin returnerad.',
                description: `${bunny.name} blev returnerad till huvudföraren.`,
            });
            setIsDialogOpen(false); // Close dialog on success
        } catch (error) {
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className='flex items-center w-full'>
                    <HomeIcon className='mr-3'/>
                    Hämta hem
                </DialogTrigger>
            </DropdownMenuItem>
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>Hämta hem</DialogTitle>
                    <DialogDescription>Hämta hem {bunny.name} från {driver.first_name} {driver.last_name}</DialogDescription>
                </DialogHeader>
                <div className='grid grid-cols-2 gap-3'>
                    <DialogClose asChild>
                        <Button type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button type="submit" onClick={handleChange} disabled={isLoading}>
                        {isLoading ? <UpdateIcon className='loader-spinner' /> : <>Hämta hem</>}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ReturnLoanedBunnyDialog;
